import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26e46292"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-relative full-width" }
const _hoisted_2 = { class: "player-preview series__background" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "player-preview__background" }, null, -1))
const _hoisted_4 = { class: "player-preview__overlay" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "series__wrapper" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ribbons" }),
  /*#__PURE__*/_createElementVNode("div", { class: "series__info" }, [
    /*#__PURE__*/_createElementVNode("h2", { class: "series__info-title" }),
    /*#__PURE__*/_createElementVNode("h6", { class: "series__info-category uppercase" })
  ])
], -1))

import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/css'
import CircleButton from '@/components/Buttons/CircleButton.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'OneVideoLoader',
  setup(__props) {

const items = [1]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Swiper), {
    onInit: _ctx.onSwiper,
    loop: true,
    slidesPerView: 1,
    "space-between": 20,
    class: "slider"
  }, {
    default: _withCtx(() => [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(items, (index) => {
        return _createVNode(_unref(SwiperSlide), {
          "data-hash": `slide${index + 1}`,
          key: `media_${index}`,
          class: "series"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _hoisted_3,
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(CircleButton, {
                    class: "btn-player__action play",
                    bg: "none",
                    name: "play",
                    iconWidth: 47,
                    iconHeight: 47,
                    "view-box": "0 0 28.58 39.49"
                  })
                ])
              ]),
              _hoisted_5
            ])
          ]),
          _: 2
        }, 1032, ["data-hash"])
      }), 64))
    ]),
    _: 1
  }, 8, ["onInit"]))
}
}

})